import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Divider,
  Stack,
  IconButton,
  Checkbox,
  Grid,
  FormControlLabel,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import {
  ASSETICONBASEURL,
  WEBSERVICE,
  showToast,
} from "../../../CoreDataService";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DataTable from "../../../Common/DataTable";
import { ContainedButton, OutlinedButton } from "../../../Common/Buttons";

const sectionStyle = {
  // backgroundColor: '#1a1a1a',
  // color: '#fff',
  borderRadius: "16px",
  padding: "32px",
  marginBottom: "40px",
  // boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
};

const tableHeadStyle = {
  // backgroundColor: '#2a2a2a',
};

const LoanOverview = () => {
  const navigate = useNavigate();
  const { btncolor, allColors } = useSelector((state) => state);
  const theme = localStorage.getItem("theme") || "dark";

  const [loansFlexible, setLoansFlexible] = useState([]);
  const [loansStable, setLoansStable] = useState([]);
  const [overviewFlexible, setOverviewFlexible] = useState([]);
  const [overviewStable, setOverviewStable] = useState([]);

  const [repayOpen, setRepayOpen] = useState(false);
  const [ltvOpen, setLtvOpen] = useState(false);

  const [selectedRepay, setSelectedRepay] = useState({});
  const [repaymentAmount, setRepaymentAmount] = useState("");
  const [repayFlag, setRepayFlag] = useState(false);
  const [disableRepay, setDisableRepay] = useState(false);

  const [selectedLtv, setSelectedLtv] = useState({});
  const [addCollateral, setAddCollateral] = useState("");

  const [openAdjustLtvModal, setOpenAdjustLtvModal] = useState(false);
  const [openLoanInfoModal, setOpenLoanInfoModal] = useState(false);
  const [openRepayModal, setOpenRepayModal] = useState(false);

  const [remainingDebt, setRemainingDebt] = useState("");
  const [ltvAfterRepay, setLtvAfterRepay] = useState("");
  const [interestAmountInUSD, setInterestAmountInUSD] = useState("");
  const [interestAmountInBorrowingAsset, setInterestAmountInBorrowingAsset] =
    useState("");
  const [remainingCollateralAmount, setRemainingCollateralAmount] =
    useState("");
  const [disableRepayFlag, setDisableRepayFlag] = useState(false);

  const [initialLtv, setInitialLtv] = useState("");
  const [is100PercentDisableForRepayment, setIs100PercentDisableForRepayment] =
    useState(false);
  const [selectedAdjustLtvDetails, setSelectedAdjustLtvDetails] = useState({
    loanId: "",
    collateralAmount: "",
    adjustedLTV: "",
  });
  const [selectedRepayDetails, setSelectedRepayDetails] = useState({
    loanId: "",
    borrowingAmount: "",
  });

  const [assetOverviewWithFlexibleRates, setAssetOverviewWithFlexibleRates] =
    useState([]);
  const [assetOverviewWithStableRates, setAssetOverviewWithStableRates] =
    useState([]);
  const [totalDebtInUsdForFlexible, setTotalDebtInUsdForFlexible] = useState(0);
  const [totalCollateralInUsdForFlexible, setTotalCollateralInUsdForFlexible] =
    useState(0);
  const [totalDebtInUsdForStable, setTotalDebtInUsdForStable] = useState(0);
  const [totalCollateralInUsdForStable, setTotalCollateralInUsdForStable] =
    useState(0);
  const [selectedPercent, setSelectedPercent] = useState(null);

  const token = localStorage.getItem("access_token");
  const uuid = localStorage.getItem("uuid");

  useEffect(() => {
    getAllLoans();
    getLoanOverview("Flexible");
  }, []);

  console.log("repaymentAmount", repaymentAmount);

  const getAllLoans = () => {
    axios
      .post(
        `${WEBSERVICE}crypto/banking/loan/getAllActiveLoansByUser`,
        { uuid },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      )
      .then(({ data }) => {
        if (data.error.error_data !== 0) {
          showToast("error", data.error.error_msg);
          return;
        }
        const flexible = [];
        const stable = [];
        data.loanDetails?.forEach((loan) => {
          if (loan.loanType.toLowerCase() === "flexible") flexible.push(loan);
          else stable.push(loan);
        });
        setLoansFlexible(flexible);
        setLoansStable(stable);
      })
      .catch(handleError);
  };

  const getLoanOverview = (loanType) => {
    axios
      .post(
        `${WEBSERVICE}crypto/banking/loan/getActiveLoanOverviewDetailsByUser`,
        {
          uuid,
          loanType,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      )
      .then(({ data }) => {
        if (data.error.error_data !== 0)
          return showToast("error", data.error.error_msg);
        const overviews = data.loanOverview || [];
        const flexible = [],
          stable = [];
        overviews.forEach((overview) => {
          (overview.loanType === "Flexible" ? flexible : stable).push(overview);
        });

        if (loanType === "Flexible") {
          setOverviewFlexible(flexible);
        } else {
          setOverviewStable(stable);
        }
      })
      .catch(handleError);
  };

  const handleError = (err) => {
    if ([401, 403].includes(err.response?.status)) {
      showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      logout();
    } else {
      showToast("error", "Could not connect to server.");
    }
  };

  const openRepayModalFunc = (loan) => {
    setSelectedRepayDetails(loan);
    setRepaymentAmount("");
    setOpenRepayModal(true);
  };

  const openLtvModal = (loan) => {
    setSelectedAdjustLtvDetails(loan);
    setAddCollateral("");
    setOpenAdjustLtvModal(true);
  };

  const handleAddCollateral = () => {
    if (!addCollateral || parseFloat(addCollateral) <= 0.0001) return;

    const payload = {
      uuid,
      loanId: selectedAdjustLtvDetails.loanId,
      collateralAmount: addCollateral,
    };

    axios
      .post(`${WEBSERVICE}crypto/banking/loan/addCollateral`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${token}`,
        },
      })
      .then(({ data }) => {
        if (data.error.error_data !== 0)
          return showToast("error", data.error.error_msg);
        showToast("success", data.error.error_msg);
        setLtvOpen(false);
        getAllLoans();
        getLoanOverview("Flexible");
      })
      .catch(handleError);
  };

  const [loanTab, setLoanTab] = useState(0);
  const [assetTab, setAssetTab] = useState(0);

  const handleLoanTabChange = (event, newValue) => setLoanTab(newValue);
  const handleAssetTabChange = (event, newValue) => {
    console.log("Asset Tab Changed", newValue);
    setAssetTab(newValue);
    if (newValue === 0) {
      getLoanOverview("Flexible");
    } else {
      getLoanOverview("7");
    }
  };

  const calculateRepayAmountData = async (val) => {
    setRepaymentAmount(val);
    if (parseFloat(val) > 0.0001) {
      if (val === selectedRepayDetails.borrowingAmount) {
        setRepayFlag(false);
        setDisableRepayFlag(true);
      }

      const payload = {
        uuid: localStorage.getItem("uuid"),
        loanId: selectedRepayDetails.loanId,
        repaymentAmount: val,
        flag: repayFlag ? 1 : 0,
      };

      try {
        const response = await fetch(
          `${WEBSERVICE}crypto/banking/loan/calculateRepayAmount`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();

        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg); // Replace with your snackbar or alert logic
        } else {
          setRemainingDebt(result.remainingBorrowingAmount);
          setLtvAfterRepay(result.ltvAfterRepay);
          setInitialLtv(result.initialLTV);
          setInterestAmountInBorrowingAsset(
            result.interestAmountInBorrowingAsset
          );
          setInterestAmountInUSD(result.interestAmountInUSD);
          setRemainingCollateralAmount(result.remainingCollateralAmount);
        }
      } catch (error) {
        if ([401, 403].includes(error?.status)) {
          // Optional: replace with your logout logic
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          logout();
        } else {
          showToast("error", "Could Not Connect To Server");
        }
      }
    }
  };

  const calculateMaxCollateralAmount = () => {
    setAddCollateral(selectedAdjustLtvDetails.collateralAmount);
    getAdjustLtvValue(selectedAdjustLtvDetails.collateralAmount); // Make sure this function is defined and uses current state values
  };
  const calculateMaxRepaymentAmount = () => {
    setRepaymentAmount(selectedRepayDetails.borrowingAmount);
    setIs100PercentDisableForRepayment(true);
    setDisableRepayFlag(true);
    calculateRepayAmountData(selectedRepayDetails.borrowingAmount);
  };
  const calculatePercentageOfRepaymentAmount = (param) => {
    const amount = selectedRepayDetails.borrowingAmount;

    if (parseFloat(amount) > 0.0001) {
      const calculatedAmount = parseFloat(amount) * (parseInt(param) / 100);
      setRepaymentAmount(calculatedAmount);
      setIs100PercentDisableForRepayment(false);
      setDisableRepayFlag(false);
      calculateRepayAmountData(calculatedAmount);
    } else {
      showToast("error", "Amount should be greater than 0.0001"); // Replace with Snackbar/toast if needed
    }
  };

  const handleCheckBoxClick = () => {
    const isFullRepayment =
      repaymentAmount === selectedRepayDetails.borrowingAmount;

    if (isFullRepayment) {
      setRepayFlag(false);
      setDisableRepayFlag(true);
    } else {
      setRepayFlag((prev) => !prev);
    }

    calculateRepayAmountData(repaymentAmount);
  };

  const getAdjustLtvValue = async (val) => {
    setAddCollateral(val);
    if (parseFloat(val) > 0.0001) {
      const payload = {
        uuid: localStorage.getItem("uuid"),
        loanId: selectedAdjustLtvDetails.loanId,
        collateralAmount: val,
      };

      try {
        const response = await fetch(
          `${WEBSERVICE}crypto/banking/loan/calculateAdjustLtv`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();

        if (result.error.error_data !== 0) {
          document.body.classList.remove("overlay");
          showToast("error", result.error.error_msg); // or use a custom alert function
        } else {
          setSelectedAdjustLtvDetails((prev) => ({
            ...prev,
            adjustedLTV: result.adjustLtv,
          }));
        }
      } catch (error) {
        document.body.classList.remove("overlay");
        if ([401, 403].includes(error?.status)) {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN"); // or use custom alert
          logout();
        } else {
          showToast("error", "Could Not Connect To Server"); // or use custom alert
        }
      }
    }
  };

  const handleRepay = async () => {
    if (repaymentAmount !== "") {
      if (repaymentAmount === selectedRepayDetails.borrowingAmount) {
        setRepayFlag(false);
        setDisableRepayFlag(true);
      }

      const payload = {
        uuid: localStorage.getItem("uuid"),
        loanId: selectedRepayDetails.loanId,
        repaymentAmount: repaymentAmount,
        flag: repayFlag ? 1 : 0,
      };

      try {
        const response = await fetch(
          `${WEBSERVICE}crypto/banking/loan/repayLoan`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();

        if (result.error.error_data !== 0) {
          document.body.classList.remove("overlay");
          showToast("error", result.error.error_msg); // Use your custom alert function if needed
        } else {
          showToast("success", result.error.error_msg); // success message
          setRepaymentAmount("");
          setRepayFlag(false);
          setDisableRepayFlag(false);
          handleRepayLoanModalClose();
          getAllLoans(); // Ensure these are defined in the component
          getAssetWiseLoanOverview("Flexible");
        }
      } catch (error) {
        document.body.classList.remove("overlay");
        if ([401, 403].includes(error?.status)) {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          logout();
        } else {
          showToast("error", "Could Not Connect To Server");
        }
      }
    } else {
      showToast("error", "Please provide valid amount");
    }
  };
  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const getAssetWiseLoanOverview = async (loanType) => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
      loanType: loanType,
    };

    try {
      const response = await fetch(
        `${WEBSERVICE}crypto/banking/loan/getActiveLoanOverviewDetailsByUser`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.error.error_data !== 0) {
        document.body.classList.remove("overlay");
        showToast("error", result.error.error_msg); // Use custom alert method if available
      } else {
        const loanOverview = result.loanOverview || [];
        const flexible = [];
        const stable = [];

        loanOverview.forEach((item) => {
          if (item.loanType === "Flexible") {
            flexible.push(item);
          } else {
            stable.push(item);
          }
        });

        setAssetOverviewWithFlexibleRates(flexible);
        setAssetOverviewWithStableRates(stable);

        if (loanType === "Flexible") {
          setTotalDebtInUsdForFlexible(
            result.loanSumAmountInUsd[0]?.totalDebtAmountInUsd || 0
          );
          setTotalCollateralInUsdForFlexible(
            result.loanSumAmountInUsd[0]?.totalCollateralAmountInUsd || 0
          );
        } else {
          setTotalDebtInUsdForStable(
            result.loanSumAmountInUsd[0]?.totalDebtAmountInUsd || 0
          );
          setTotalCollateralInUsdForStable(
            result.loanSumAmountInUsd[0]?.totalCollateralAmountInUsd || 0
          );
        }
      }
    } catch (error) {
      document.body.classList.remove("overlay");
      if ([401, 403].includes(error?.status)) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        logout();
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const handleRepayLoanModalClose = () => {
    setOpenRepayModal(false);
    handleRepayLoanDataReset();
  };

  const handleRepayLoanDataReset = () => {
    setRepaymentAmount("");
    setSelectedPercent(null);
    setRepayFlag(false);
    setLtvAfterRepay("");
    setInitialLtv("");
    setRemainingDebt("");
    setInterestAmountInUSD("");
    setInterestAmountInBorrowingAsset("");
    setRemainingCollateralAmount("");
    setSelectedRepayDetails({
      loanId: "",
      borrowingAmount: "",
    });
  };

  const handleAmountChange = (value) => {
    setSelectedPercent(null); // re-enable buttons
    calculateRepayAmountData(value);
  };

  return (
    <Box sx={{ p: 1, bgcolor: "background.card", minHeight: "100vh" }}>
      {/* Loan Overview */}
      <Paper sx={sectionStyle}>
        <Typography variant="h5" align="center" gutterBottom>
          Loan Overview
        </Typography>
        <Divider sx={{ mb: 2, bgcolor: "background.paper" }} />
        <Tabs
          value={loanTab}
          onChange={handleLoanTabChange}
          textColor="inherit"
          indicatorColor="primary"
          centered
        >
          <Tab label="Flexible Rate" />
          <Tab label="Stable Rate" />
        </Tabs>

        {loanTab === 0 && (
          <DataTable
            columns={[
              "Borrowed Asset",
              "Borrowed Amount",
              "Collateral Asset",
              "Collateral Amount",
              "Initial LTV",
              "Current LTV",
              "Margin Call",
              "Liquidation LTV",
              "Liquidation Price",
              "Annualized Interest Rate",
              "Action",
            ]}
          >
            {loansFlexible ? (
              loansFlexible.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor:
                      theme === "dark"
                        ? allColors.tableBodyColor
                        : allColors.lightTableBodyColor,
                    borderRadius: "10px",
                  }}
                >
                  <TableCell>{row.loanableAsset}</TableCell>
                  <TableCell>{row.initialBorrowingAmount}</TableCell>
                  <TableCell>{row.collateralAsset}</TableCell>
                  <TableCell>{row.collateralAmount}</TableCell>
                  <TableCell>{row.initialLTV}</TableCell>
                  <TableCell>{row.adjustedLTV}</TableCell>
                  <TableCell>{row.marginCallPrice}</TableCell>
                  <TableCell>{row.liquidationLTV}</TableCell>
                  <TableCell>{row.liquidationPrice}</TableCell>
                  <TableCell>{row.annualizedInterestRate}</TableCell>

                  <TableCell sx={{ padding: "5px 0" }}>
                    <ContainedButton
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{
                        mb: 1,
                        width: "100%",
                      }}
                      onClick={() => openRepayModalFunc(row)}
                    >
                      Repay
                    </ContainedButton>
                    <OutlinedButton
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{
                        width: "100%",
                      }}
                      onClick={() => openLtvModal(row)}
                    >
                      Adjust LTV
                    </OutlinedButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <Typography>Loading...</Typography>
                </TableCell>
              </TableRow>
            )}
          </DataTable>
        )}

        {loanTab === 1 && (
          <DataTable
            columns={[
              "Borrowed Asset",
              "Borrowed Amount",
              "Collateral Asset",
              "Collateral Amount",
              "Initial LTV",
              "Current LTV",
              "Margin Call",
              "Liquidation LTV",
              "Liquidation Price",
              "Annualized Interest Rate",
              "Action",
            ]}
          >
            {loansStable ? (
              loansStable.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor:
                      theme === "dark"
                        ? allColors.tableBodyColor
                        : allColors.lightTableBodyColor,
                    borderRadius: "10px",
                  }}
                >
                  <TableCell>{row.loanableAsset}</TableCell>
                  <TableCell>{row.initialBorrowingAmount}</TableCell>
                  <TableCell>{row.collateralAsset}</TableCell>
                  <TableCell>{row.collateralAmount}</TableCell>
                  <TableCell>{row.initialLTV}</TableCell>
                  <TableCell>{row.adjustedLTV}</TableCell>
                  <TableCell>{row.marginCallPrice}</TableCell>
                  <TableCell>{row.liquidationLTV}</TableCell>
                  <TableCell>{row.liquidationPrice}</TableCell>
                  <TableCell>{row.annualizedInterestRate}</TableCell>

                  <TableCell spacing={1} sx={{ padding: "5px 0" }}>
                    <ContainedButton
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{
                        mb: 1,
                        width: "100%",
                      }}
                      onClick={() => openRepayModalFunc(row)}
                    >
                      Repay
                    </ContainedButton>
                    <OutlinedButton
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{
                        width: "100%",
                      }}
                      onClick={() => openLtvModal(row)}
                    >
                      Adjust LTV
                    </OutlinedButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <Typography>Loading...</Typography>
                </TableCell>
              </TableRow>
            )}
          </DataTable>
        )}
      </Paper>

      {/* Asset Overview */}
      <Paper sx={sectionStyle}>
        <Typography variant="h5" align="center" gutterBottom>
          Asset Overview
        </Typography>
        <Divider sx={{ mb: 2, bgcolor: "#444" }} />
        <Tabs
          value={assetTab}
          onChange={handleAssetTabChange}
          textColor="inherit"
          indicatorColor="primary"
          centered
        >
          <Tab label="Flexible Rate" />
          <Tab label="Stable Rate" />
        </Tabs>

        {assetTab === 0 && (
          <>
            <Box display="flex" justifyContent="space-around" mt={3} mb={2}>
              <Typography variant="body1">
                Total Debt (USD): <strong>4809.76</strong>
              </Typography>
              <Typography variant="body1">
                Total Collateral (USD): <strong>16889.77</strong>
              </Typography>
            </Box>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={4}
              justifyContent="center"
              mt={3}
              mb={2}
            >
              <Box flex={1}>
                <DataTable
                  columns={["Borrowing Asset", "Amount", "Value (USD)"]}
                >
                  {overviewFlexible ? (
                    overviewFlexible.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            theme === "dark"
                              ? allColors.tableBodyColor
                              : allColors.lightTableBodyColor,
                          borderRadius: "10px",
                        }}
                      >
                        <TableCell>{row.loanableAsset}</TableCell>
                        <TableCell>{row.borrowingAmount}</TableCell>
                        <TableCell>{row.loanAssetPriceInUsd}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        <Typography>Loading...</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </DataTable>
              </Box>

              <Box flex={1}>
                <DataTable
                  columns={["Collateral Asset", "Amount", "Value (USD)"]}
                >
                  {overviewFlexible ? (
                    overviewFlexible.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            theme === "dark"
                              ? allColors.tableBodyColor
                              : allColors.lightTableBodyColor,
                          borderRadius: "10px",
                        }}
                      >
                        <TableCell>{row.collateralAsset}</TableCell>
                        <TableCell>{row.collateralAmount}</TableCell>
                        <TableCell>{row.collAssetPriceInUsd}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        <Typography>Loading...</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </DataTable>
              </Box>
            </Stack>
          </>
        )}

        {assetTab === 1 && (
          <>
            <Box display="flex" justifyContent="space-around" mt={3} mb={2}>
              <Typography variant="body1">
                Total Debt (USD): <strong>4809.76</strong>
              </Typography>
              <Typography variant="body1">
                Total Collateral (USD): <strong>16889.77</strong>
              </Typography>
            </Box>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={4}
              justifyContent="center"
              mt={3}
              mb={2}
            >
              <Box flex={1}>
                <DataTable
                  columns={["Borrowing Asset", "Amount", "Value (USD)"]}
                >
                  {overviewStable ? (
                    overviewStable.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            theme === "dark"
                              ? allColors.tableBodyColor
                              : allColors.lightTableBodyColor,
                          borderRadius: "10px",
                        }}
                      >
                        <TableCell>{row.loanableAsset}</TableCell>
                        <TableCell>{row.borrowingAmount}</TableCell>
                        <TableCell>{row.loanAssetPriceInUsd}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        <Typography>Loading...</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </DataTable>
              </Box>

              <Box flex={1}>
                <DataTable
                  columns={["Collateral Asset", "Amount", "Value (USD)"]}
                >
                  {overviewStable ? (
                    overviewStable.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            theme === "dark"
                              ? allColors.tableBodyColor
                              : allColors.lightTableBodyColor,
                          borderRadius: "10px",
                        }}
                      >
                        <TableCell>{row.collateralAsset}</TableCell>
                        <TableCell>{row.collateralAmount}</TableCell>
                        <TableCell>{row.collAssetPriceInUsd}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        <Typography>Loading...</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </DataTable>
              </Box>
            </Stack>
          </>
        )}
      </Paper>

      {/* Repay Modal */}
      <Dialog
        open={openRepayModal}
        onClose={() => handleRepayLoanModalClose()}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 3, p: 2, boxShadow: 6 },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1,
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            R
          </Typography>
          <Typography variant="h6" fontWeight={600}>
            Repay Loan
          </Typography>
          <IconButton onClick={() => handleRepayLoanModalClose()}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ pt: 1 }}>
          <Typography variant="subtitle2" gutterBottom>
            Repayment Amount (R)
          </Typography>

          <Grid container spacing={1} alignItems="center">
            <Grid size={6}>
              <TextField
                fullWidth
                value={repaymentAmount}
                onChange={(e) => handleAmountChange(e.target.value)}
                placeholder="Enter amount"
                size="small"
                variant="outlined"
              />
            </Grid>
            <Grid size={3}>
              <OutlinedButton
                variant="outlined"
                onClick={calculateMaxRepaymentAmount}
                fullWidth
                sx={{
                  height: "40px",
                }}
              >
                Max
              </OutlinedButton>
            </Grid>
            <Grid size={3} display="flex" alignItems="center">
              <img
                src={`${ASSETICONBASEURL}${selectedRepayDetails.loanableAsset}.png`}
                height="20"
                width="20"
                alt=""
                style={{ marginRight: 6 }}
              />
              <Typography variant="body2">
                {selectedRepayDetails.loanableAsset}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1} sx={{ my: 2 }}>
            {[25, 50, 75, 100].map((percent) => (
              <Grid size={3} key={percent}>
                <ContainedButton
                  variant="contained"
                  fullWidth
                  size="small"
                  onClick={() => {
                    calculatePercentageOfRepaymentAmount(percent);
                    setSelectedPercent(percent); // mark this as selected
                  }}
                  disabled={selectedPercent === percent}
                  sx={{
                    textTransform: "none",
                  }}
                >
                  {percent}%
                </ContainedButton>
              </Grid>
            ))}
          </Grid>

          <FormControlLabel
            control={
              <Checkbox
                checked={repayFlag}
                onClick={handleCheckBoxClick}
                disabled={disableRepayFlag}
              />
            }
            label="Keep my collateral in place and reduce loan LTV"
            sx={{ mb: 2 }}
          />

          {[
            {
              label: "Total Debt (D)",
              value: selectedRepayDetails.borrowingAmount,
            },
            { label: "Remaining Debt", value: remainingDebt },
            {
              label: "LTV after Repayment",
              value: `${ltvAfterRepay}% / ${initialLtv}%`,
            },
            {
              label: "Interest Charges [I]",
              value: `${interestAmountInUSD} USD / ${interestAmountInBorrowingAsset} ${selectedRepayDetails.loanableAsset}`,
            },
            {
              label: "Returned Collateral Amount [CR]",
              value: `${remainingCollateralAmount} ${selectedRepayDetails.collateralAsset}`,
            },
          ].map(({ label, value }) => (
            <Grid container key={label} sx={{ mt: 1 }}>
              <Grid size={7}>
                <Typography variant="body2">{label}</Typography>
              </Grid>
              <Grid size={5}>
                <Typography variant="body2" align="right" fontWeight={500}>
                  {value}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <ContainedButton
            variant="contained"
            fullWidth
            size="large"
            onClick={handleRepay}
            sx={{
              textTransform: "none",
              borderRadius: 2,
            }}
          >
            Repay Now
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* Adjust LTV Modal */}
      <Dialog
        open={openAdjustLtvModal}
        onClose={() => setOpenAdjustLtvModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ textAlign: "center" }}>
          Adjust LTV
          <IconButton
            aria-label="close"
            onClick={() => setOpenAdjustLtvModal(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid size={6}>
              <Typography>Total Debt</Typography>
              <Typography>
                {selectedAdjustLtvDetails.borrowingAmount}{" "}
                {selectedAdjustLtvDetails.loanableAsset}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography>Collateral Amount</Typography>
              <Typography>
                {selectedAdjustLtvDetails.collateralAmount}{" "}
                {selectedAdjustLtvDetails.collateralAsset}
              </Typography>
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 2 }}>
            <Grid size={6}>
              <Typography>Initial LTV</Typography>
            </Grid>
            <Grid size={6} textAlign="start" sx={{ paddingLeft: 1 }}>
              <Typography>{selectedAdjustLtvDetails.initialLTV}%</Typography>
            </Grid>
          </Grid>

          <Typography sx={{ mt: 2 }}>Add Collateral</Typography>
          <Grid container spacing={1}>
            <Grid size={6}>
              <TextField
                fullWidth
                value={addCollateral}
                onChange={(e) => getAdjustLtvValue(e.target.value)}
                placeholder="Enter Amount"
              />
            </Grid>
            <Grid size={3}>
              <ContainedButton
                variant="contained"
                sx={{ height: "55px" }}
                onClick={() => calculateMaxCollateralAmount()}
                fullWidth
              >
                Max
              </ContainedButton>
            </Grid>
            <Grid size={3} sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={`${ASSETICONBASEURL}${selectedAdjustLtvDetails.collateralAsset}.png`}
                height="20"
                width="20"
                alt=""
              />
              &nbsp;{selectedAdjustLtvDetails.collateralAsset}
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 2 }}>
            <Grid size={6}>
              <Typography>Adjusted LTV</Typography>
            </Grid>
            <Grid size={6} textAlign="start" sx={{ paddingLeft: 1 }}>
              <Typography>{selectedAdjustLtvDetails.adjustedLTV}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ContainedButton
            variant="contained"
            fullWidth
            onClick={handleAddCollateral}
            disabled={!addCollateral}
          >
            Add Collateral
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* Loan Info Modal */}
      <Dialog
        open={openLoanInfoModal}
        onClose={() => setOpenLoanInfoModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Information
          <IconButton
            aria-label="close"
            onClick={() => setOpenLoanInfoModal(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {/* Add info content here if needed */}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default LoanOverview;
